import { Info } from 'lucide-react';

// A CIRCLED "i" THAT REVEALS A PARAGRAPH, on hover or focus — the mark beside a title that
// says what the thing under it does.
//
// One definition, because there are two of them now: the phase's own heading
// (EtapeSection) and a subphase's (Phase 5's two cards), which sit in the same place on the
// same dark page and must not explain themselves in two different-looking boxes.
//
// FIXED LIGHT on the button and a light panel under it: both live directly on the blueprint
// page, where there is no card behind them and a slate-700 glyph would be the colour of the
// paper it is drawn on.
//
// NOT IN THE LAYOUT UNTIL SHOWN (`hidden`, not a zero opacity): a transparent 36rem panel
// still counts towards the page's width, and on a phone it made the whole page slide
// sideways. And on a phone it is a panel across the screen rather than one centred on the
// "i", which sits off centre and would push half of it out of view.
export function InfoTip({ text }: { text: string }) {
  return (
    <span className="group relative inline-flex">
      <button
        type="button"
        aria-label={text}
        className="text-slate-300 transition-colors hover:text-blue-300 focus:outline-none focus-visible:text-blue-300"
      >
        <Info className="h-4 w-4" />
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 top-full z-20 mt-2 hidden w-[36rem] max-w-[90vw] -translate-x-1/2 whitespace-pre-line rounded-lg border border-slate-200 bg-white p-4 text-left text-sm font-normal leading-relaxed text-slate-700 shadow-lg group-hover:block group-focus-within:block max-sm:fixed max-sm:inset-x-4 max-sm:top-24 max-sm:mt-0 max-sm:w-auto max-sm:max-w-none max-sm:translate-x-0"
      >
        {text}
      </span>
    </span>
  );
}
